var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "timer" }, [
    _vm.expired
      ? _c("div", [
          _c("span", { staticClass: "countdown expired" }, [
            _vm._v("Cart expired"),
          ]),
        ])
      : _c("div", [
          _c("span", [_vm._v("Cart available for ")]),
          _vm._v(" "),
          _c(
            "strong",
            {
              ref: "countdown",
              class: "countdown " + (_vm.expiring ? "expiring" : ""),
            },
            [_vm._v(_vm._s(_vm.clockReadout))]
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }